/* @flow */
import { ActionTypes } from '../constants/MessageComposerConstants';
import { dispatcher } from 'lib/Dispatcher';

const MessageComposerActions = {

  saveState(chatId: string, state: Object) {
    dispatcher.dispatch({
      type: ActionTypes.SAVE_STATE,
      chatId,
      state,
    });
  },

};

export default MessageComposerActions;



// WEBPACK FOOTER //
// ./src/chat/actions/MessageComposerActions.js